import React from "react";
import { useEffect, useState } from "react";
import { AppBar, Grid, Tab } from "@mui/material";

import { Box } from "@mui/system";
import { Tabs } from "@mui/material";
import TabPanel from "../../components/TabPanel";
import DocsAccordian from "../MachineOverviewPage/_tabs/Documentation/DocsAccordian";
import i18n from "../../reducers/i18n";
import mime from "mime";
import CardButton from "../../components/CardButton";

import { ReactComponent as HorizontalLineSvg } from "../../assets/HorizontalLine.svg";
import AdminFaq from "../Users/AdminFaq";

import Feedback from "./Feedback";
import { getSupportJson } from "../../actions/user";
import { connect, useDispatch, useStore } from "react-redux";

export default connect(({ supportJson }) => ({ supportJson }), {
  getSupportJson,
})((props) => {
  const [appBarValue, setAppBarValue] = useState(0);

  const [qaData, setQaData] = useState([]);

  function a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`,
    };
  }

  const handleAppBarChange = (event, newValue) => {
    setAppBarValue(newValue);
  };

  const AttachmentInternal = [
    {
      attachment: {
        title: "test title",
        description: "test description",
        file: {
          fileid:
            "5e35622c-e942-4d75-aed2-5f7225fba6f9/2d2b94b5-95bb-4bb3-8a32-b701f9d277fd.pdf",
          fileversion: "22f829ae-12ed-406b-96fd-d57c359e7a8a",
          mimetype: "application/pdf",
          url:
            "https://minio.service.staging.stmesunet.247factorynet.com/clientprecisionpartsgmbh/247uptime.io/cfc04ba6-9dcd-4259-92fb-43bc8b85c2ff/5e35622c-e942-4d75-aed2-5f7225fba6f9/2d2b94b5-95bb-4bb3-8a32-b701f9d277fd.pdf?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=8098e87wjBEmspptmzGn%2F20241007%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20241007T144746Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=6e32caa657f06a393e7551e854786a07d6644ffd0a4da4ca03d15ed34eed0ad4",
        },
        specifier: "internal attachment",
        nodeid: "247fn://247uptime.io/cfc04ba6-9dcd-4259-92fb-43bc8b85c2ff",
      },
    },
    {
      attachment: {
        title: null,
        description: null,
        file: {
          fileid:
            "eq2doc357803f1b-83f0-4769-ad72-91853147498a/eq2doc357803f1b-83f0-4769-ad72-91853147498b.pdf",
          fileversion: "101a58a5-9aec-43df-9591-f8816014d542",
          mimetype: "application/pdf",
          url:
            "https://minio.service.staging.stmesunet.247factorynet.com/clientprecisionpartsgmbh/247uptime.io/precisionparts-eq2doc3/eq2doc357803f1b-83f0-4769-ad72-91853147498a/eq2doc357803f1b-83f0-4769-ad72-91853147498b.pdf?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=8098e87wjBEmspptmzGn%2F20241007%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20241007T144746Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=346e2e06d94dac6166c823142c026a2a281676de5d0efe7da6d898af063bf6d5",
        },
        specifier: "internal attachment",
        nodeid: "247fn://247uptime.io/precisionparts-eq2doc3",
      },
    },
    {
      attachment: {
        title: null,
        description: null,
        file: {
          fileid:
            "eq2doc257803f1b-83f0-4769-ad72-91853147498a/eq2doc257803f1b-83f0-4769-ad72-91853147498b.pdf",
          fileversion: "101a58a5-9aec-43df-9591-f8816014d542",
          mimetype: "application/pdf",
          url:
            "https://minio.service.staging.stmesunet.247factorynet.com/clientprecisionpartsgmbh/247uptime.io/precisionparts-eq2doc2/eq2doc257803f1b-83f0-4769-ad72-91853147498a/eq2doc257803f1b-83f0-4769-ad72-91853147498b.pdf?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=8098e87wjBEmspptmzGn%2F20241007%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20241007T144746Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=21cbb7a7f6f28da96547baf8d7e91c1b05f5db9795e550a027d55c7548be40d5",
        },
        specifier: "internal attachment",
        nodeid: "247fn://247uptime.io/precisionparts-eq2doc2",
      },
    },
    {
      attachment: {
        title: null,
        description: null,
        file: {
          fileid:
            "eq2doc157803f1b-83f0-4769-ad72-91853147498a/eq2doc157803f1b-83f0-4769-ad72-91853147498b.pdf",
          fileversion: "101a58a5-9aec-43df-9591-f8816014d542",
          mimetype: "application/pdf",
          url:
            "https://minio.service.staging.stmesunet.247factorynet.com/clientprecisionpartsgmbh/247uptime.io/precisionparts-eq2doc1/eq2doc157803f1b-83f0-4769-ad72-91853147498a/eq2doc157803f1b-83f0-4769-ad72-91853147498b.pdf?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=8098e87wjBEmspptmzGn%2F20241007%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20241007T144746Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=a036aa0df7b8c3bafebd2a15ffbc4d47998354eae67bffa83a2923ce85573b04",
        },
        specifier: "internal attachment",
        nodeid: "247fn://247uptime.io/precisionparts-eq2doc1",
      },
    },
  ];

  useEffect(() => {
    props.getSupportJson();
  }, []);

  useEffect(() => {
    if (Object.keys(props.supportJson).length) {
      setQaData(
        props.supportJson.faqs.map((faq) => {
          return { question: faq.question.de, answer: faq.answer.de };
        })
      );
    }
  }, [props.supportJson]);

  return (
    <div className="help_and_feedback" style={{ marginBottom: "15%"}}>
      <Box
        sx={{
          bgcolor: "background.paper",
        }}
      >
        <AppBar
          className="appBar"
          position="static"
          variant="elevation"
          sx={{ borderTopLeftRadius: "4px", borderTopRightRadius: "4px" }}
        >
          <Tabs
            value={appBarValue}
            onChange={(e, v) => handleAppBarChange(e, v)}
            indicatorColor="secondary"
            textColor="inherit"
            aria-label="full width tabs example"
          >
            {/* <Tab className="tab" label="Ihr Abo" {...a11yProps(0)} disabled /> */}
              <Tab
              className="tab"
              label={i18n().help.documentation}
              {...a11yProps(0)}
              style={{
                padding: "0px 25px",
                margin: "0px",
                borderTopLeftRadius: "4px",
              }}
            />
            <Tab className="tab" label={i18n().help.feedback} {...a11yProps(1)} />
          </Tabs>
        </AppBar>

        <TabPanel
          value={appBarValue}
          index={0}
          style={{
            marginBottom: "8%",
          }}
        >
          <div className="_content" style={{ padding: "25px" }}>
            <div className="_header">
              <div className="_title">{i18n().help.documentation}</div>

              <Grid
                container
                spacing={1}
                style={{ marginTop: "10px", marginLeft: "0px", width: "100%" }}
              >
                <DocsAccordian
                  classname={"help_and_feedback_accordian"}
                  title={
                    props.supportJson?.categories &&
                    props.supportJson?.categories[0].name.de
                  }
                  docsCount={AttachmentInternal.length}
                >
                  {props.supportJson?.categories &&
                  props.supportJson?.categories[0].documents.length > 0
                    ? props.supportJson?.categories[0].documents.map(
                        (item, key) => {
                          let mimeType = mime.getExtension(item.mimeType);
                          return (
                            <React.Fragment key={key}>
                              <div
                                className="_content"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  window.open(
                                    "https://" +
                                      props.supportJson.s3Host +
                                      item.s3Path
                                  );
                                }}
                              >
                                <div className="_titleP">
                                  {item.title.de}
                                  <span
                                    className="_desc"
                                    style={{ marginLeft: "10px" }}
                                  >
                                    {("" + mimeType).toLocaleUpperCase()}
                                  </span>
                                </div>
                                {/* <div className="_desc">{item.subTitle.de}</div> */}
                                {props.supportJson?.categories[0].documents
                                  .length ===
                                key + 1 ? (
                                  <div style={{ marginTop: "10px" }}></div>
                                ) : (
                                  <HorizontalLineSvg
                                    style={{ margin: "10px 0px" }}
                                  />
                                )}
                              </div>
                            </React.Fragment>
                          );
                        }
                      )
                    : ""}
                </DocsAccordian>

                <DocsAccordian
                  classname={"help_and_feedback_accordian"}
                  style={{ margin: "20px 0px 50px 0px" }}
                  title={
                    props.supportJson?.categories &&
                    props.supportJson?.categories[1].name.de
                  }
                  docsCount={AttachmentInternal.length}
                >
                  {props.supportJson?.categories &&
                  props.supportJson?.categories[1].documents.length > 0
                    ? props.supportJson?.categories[1].documents.map(
                        (item, key) => {
                          let mimeType = mime.getExtension(item.mimeType);
                          return (
                            <React.Fragment key={key}>
                              <div
                                className="_content"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  window.open(
                                    "https://" +
                                      props.supportJson.s3Host +
                                      item.s3Path
                                  );
                                }}
                              >
                                <div className="_titleP">
                                  {item.title.de}
                                  <span
                                    className="_desc"
                                    style={{ marginLeft: "10px" }}
                                  >
                                    {("" + mimeType).toLocaleUpperCase()}
                                  </span>
                                </div>
                               {/*  <div className="_desc">{item.subTitle.de}</div> */}
                                {props.supportJson?.categories[1].documents
                                  .length ===
                                key + 1 ? (
                                  <div style={{ marginTop: "10px" }}></div>
                                ) : (
                                  <HorizontalLineSvg
                                    style={{ margin: "10px 0px" }}
                                  />
                                )}
                              </div>
                            </React.Fragment>
                          );
                        }
                      )
                    : ""}
                </DocsAccordian>

                <div className="admin-footer" style={{ width: "100%" }}>
                  <div className="faq" style={{ width: "55%" }}>
                    <div className="_title">{i18n().help.faq}</div>
                    <div className="_answer">
                      <AdminFaq data={qaData} />
                    </div>
                  </div>

                  <div className="admin-customer" style={{ width: "45%" }}>
                    <div
                      className="_title"
                      style={{ marginBottom: "0", margin: "6% 0% 1% 0%" }}
                    >
                      Kundenservice
                    </div>
                    <div className="avatarWrapper">
                      <div className="avatar">
                        <div className="bxShadow" />
                      </div>
                      <div className="avatarContent">
                        <div className="_name">{i18n().help.supportPerson}</div>
                        {/* <div className="_phone">
                          {" "}
                          <a href="tel:+49 (0)8158 9239817">
                            +49 (0)8158 9239817
                          </a>
                        </div> */}
                        <div className="_email">
                          {" "}
                          <a href="mailto:support@247factorynet.com">
                            support@247factorynet.com
                          </a>
                        </div>
                        <div className="_timing">{i18n().help.supportHours}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </Grid>
            </div>
          </div>
        </TabPanel>

        <TabPanel
          value={appBarValue}
          index={1}
          style={{
            marginBottom: "8%",
          }}
        >
          <Feedback />
        </TabPanel>
      </Box>{" "}
    </div>
  );
});
